import React, { useMemo, useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { transparentize } from 'polished';

import { tests } from './helpers';

import getStoreUrl from '../../helpers/getStoreUrl';

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  flex: 1 1 auto;

  width: 150%;
  margin: 0 -25%;

  padding: 0px 25%;
  @media (min-width: 1024px) {
    padding: 30px 25%;
  }

  &:before,
  &:after {
    content: '';
    top: 0;
    position: absolute;
    width: 10%;
    height: 100%;
    flex: 0 0 auto;
    z-index: 2;
  }

  &:before {
    left: 0;
    background:
      linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  &:after {
    right: 0;
    background:
      linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }
`;

const Track = styled.div`
  position: relative;
  overflow: scroll;
  height: 100%;
  flex: 1 1 auto;

  width: 150%;
  margin: 0 -25%;

  padding: 20px 25%;
  @media (min-width: 1024px) {
    padding: 30px 25%;
  }

  display: flex;
  gap: 20px;

  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const InnerWrap = styled.div`
  position: relative;
  width: 95%;
  height: 100%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:after {
    content: '';
    position: absolute;
    top: -20px;
    left: 0;
    right: 0;
    bottom: 30px;
    border-radius: 20px;
    background: ${({ theme }) => transparentize(
      0.9, theme.less.secondaryColor)};

    border: 1px solid ${({ theme }) => theme.less.secondaryColor};

    transition: opacity 400ms ${({ isActive }) => (isActive ? '200ms' : '0ms')};
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  }
`;

const Element = styled.iframe`
  width: 95%;
  height: 100%;
  flex: 0 0 auto;

  border: none;
  margin: 0;
  padding: 0;
  z-index: 1;
  position: relative;

  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

  scroll-snap-align: center;

  min-height: 500px;
  @media (min-width: 1024px) {
    min-height: 600px;
  }
`;

const Preview = styled.a`
  padding: 10px 20px;
  border-radius: 100px;
  background: #f7a80c;
  margin-top: 10px;
  color: #fff !important;
  z-index: 3;
`;

export const fieldHomepagePicker = ['FieldReact', {
  name: 'pageSample',
  label: null,
  renderContent: (props) => {
    const { FieldHomepagePick } = props;
    return (
      <FieldHomepagePick {...props} />
    );
  },
  FieldHomepagePick: (props) => {
    const { data = {} } = props;
    const { pageSamples = [] } = data;

    const [currentIndex, setCurrentIndex] = useState(
      pageSamples.findIndex(pageSample => pageSample._id === props.value) || 0
    );
    const trackRef = useRef(null);

    const updateCurrentIndex = () => {
      const scrollPosition = trackRef.current.scrollLeft;
      const elementWidth = trackRef.current.offsetWidth / 1.5;
      const newIndex = Math.round(scrollPosition / elementWidth);
      setCurrentIndex(newIndex);
    };

    const pageSampleCurrent = useMemo(
      () => pageSamples[currentIndex],
      [pageSamples, currentIndex],
    );

    useEffect(() => {
      const trackElement = trackRef.current;
      trackElement.addEventListener('scroll', updateCurrentIndex);

      return () => {
        trackElement.removeEventListener('scroll', updateCurrentIndex);
      };
    }, []);

    useEffect(() => {
      if (pageSampleCurrent) {
        if (props.value !== pageSampleCurrent._id) {
          props.onChange(pageSampleCurrent._id);
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSampleCurrent]);

    return (
      <Wrapper>
        <Track ref={trackRef}>
          {pageSamples.map((pageSample, i) => {
            const pageUrl = `${
              getStoreUrl(data)
            }/${
              pageSample.pageSlug
            }?store-style-overrides=${
              pageSample.previewStore
            }`;
            return (
              <InnerWrap
                key={pageSample._id}
                isActive={i === currentIndex}
              >
                <Element
                  src={pageUrl}
                />
                {i === pageSamples.length - 1 && (
                  <div
                    style={{ width: 'calc(25% - 20px)', flex: '0 0 auto' }}
                  />
                )}
                <Preview
                  href={pageUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Preview
                </Preview>
              </InnerWrap>
            );
          })}
        </Track>
      </Wrapper>
    )
  },
  skip: [tests.skipIfStepNotHomepage],
  virtual: [() => false],
  getInitialValue: (field, { data }) => (
    data.pageSample || data.pageSamples?.[0]?._id
  ),
}];

export const FIELDS = [
  fieldHomepagePicker,
];
